import React from "react";
import { connect, ConnectedProps } from 'react-redux';
import { Redirect } from "react-router-dom";
import { Header, Icon } from "semantic-ui-react";
import userManager from '../userManager';
import { ApplicationState } from '../..';
import * as Core from '../../core';

const connector = connect(
    (state: ApplicationState) => ({
        loggedIn: state.core.auth.loggedIn,
    }),
    Core.actions,
)
type PropsFromRedux = ConnectedProps<typeof connector>

type SigninCallbackProps = PropsFromRedux

class SigninCallback extends React.Component<SigninCallbackProps> {

    componentDidMount() {
        userManager.signinRedirectCallback()
            .then((user) => this.props.loginSuccess(user))
            .catch(error => this.gestioneErroreLogin(error));
    }

    render() {
        return (
            this.props.loggedIn ?
                <Redirect to="/contributi" /> :
                (
                <Header icon={true} textAlign="center">
                    <Icon name="sign-in" />
                    Stiamo completando la procedura di login...
                </Header>
                )
        );
    }

    gestioneErroreLogin = (error: any) => {
        if (error.message.includes("iat is in the future")) {
            const message = // va lasciata cosi la stringa sotto, altrimenti vengono impostati degli spazi nel messaggio
                `L'orario del tuo pc � incongruente con quello del server. 
Per motivi di sicurezza il login non risulta valido.`;
            window.alert(message);
        }

        this.props.loginError();
    }
}

export default connector(SigninCallback);
